import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InputSelect from '../../Forms/InputSelect.jsx';
import Positions from '../../Forms/Data/Positions.js';
import nationalities from '../../Forms/Data/nationalities.js';
import InputText from '../../Forms/InputText.jsx';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import PaperRow from './PaperRow.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Papers = () => {
  const { SetNotification } = useStateContext();
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [papersPerPage, setPapersPerPage] = useState(7);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/papers/conferences/1');
        const { papers } = await response.data;
        setPapers(papers);
        setLoading(true);
      } catch (error) {
        SetNotification('Error fetching data:', 'danger');
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const indexOfLastPaper = currentPage * papersPerPage;
  const indexOfFirstPaper = indexOfLastPaper - papersPerPage;
  const currentPapers = papers.slice(indexOfFirstPaper, indexOfLastPaper);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className='card-body px-0 pb-2'>
        <div className='p-0 border'>
          <table className='border table  text-center justify-content-center mb-0 text-dark'>
            <thead>
              <tr className='ro2'>
                <th className='col-2'>Researcher Name</th>
                <th className='col-2'>Paper Title</th>
                <th className='col-2'>Download</th>
                <th className='col-3'>Status</th>
                <th className='col-3'>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                currentPapers.map((paper) => (
                  <PaperRow key={paper.id} paper={paper} />
                ))
              ) : (
                <tr>
                  <td colSpan='3'><Loader label="Loading papers..." /></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className='pagination m-2 p-2 '>
          {papers.length > papersPerPage && (
            <ul className='pagination m-2 '>
              {Array(Math.ceil(papers.length / papersPerPage))
                .fill()
                .map((_, index) => (
                  <li key={index} className='page-item'>
                    <button className='page-link' onClick={() => paginate(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default Papers;